export default __webpack_public_path__ + "static/design-a20665afe8cf3fbe508ca2e8e1fa4ead.png";